// utils/buildPaymentPayload.js
export function buildPaymentPayload({ paymentType, license, customerName, customerCpf }) {
  if (!paymentType) {
    throw new Error('Selecione uma forma de pagamento');
  }

  if (!license?.license_type) {
    throw new Error('Licença inválida');
  }

  const name = customerName?.trim() || '';
  if (!name) {
    throw new Error('Informe seu nome completo');
  }

  const cpf = customerCpf?.replace(/\D/g, '') || '';
  if (cpf.length !== 11) {
    throw new Error('Informe um CPF válido com 11 dígitos');
  }

  return {
    paymentType: 'CHECKOUT_PRO',
    order: {
      license_code: license.license_code,
      license_type: license.license_type,
      licenseId: license.license_code,
      amount: license.price,
      currency: 'BRL',
      description: license.license_name ?? license.license_code,
    },
    customer: {
      name,
      cpf,
    },
    metadata: {
      preferred_payment_type: paymentType,
    },
  };
}
